import React, { Component } from 'react';
import { first, reduce, each, values } from 'lodash';
import PropTypes from 'prop-types';
import ordinal from 'ordinal-js';
import Fa from 'react-fontawesome';
import styles from './styles.css';

class AnswerBox extends Component {
  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderGeneric() {
    const { answers, className } = this.props;
    return answers.map((answer, idx) => (
      <div key={`answer-${idx}`} className={className}>
        {answer.instance_label !== undefined && <div><strong>{answer.instance_label}</strong></div>}
        {this.renderHTML(answer.text)}
      </div>
    ));
  }

  renderType1Loop() {
    // Single Select, looping
    const { answers, className } = this.props;
    const headers = values(reduce(answers, (items, answer) => {
      each(answer.loop_instances, (l) => {
        items[l.value] = { ...l };
      });
      return items;
    }, {}));

    if (answers.length <= 2) {
      // reverse
      // switch columns and rows if there are too many columns
      return (
        <div className={className}>
          <table className="table table-condensed">
            <thead>
              <tr>
                <th>&nbsp;</th>
                {answers.map(answer => (
                  <th className="text-center" key={answer.value}>
                    {this.renderHTML(answer.text)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {headers.map(header => (
                <tr key={header.value}>
                  <th>
                    {this.renderHTML(header.text)}
                  </th>
                  {answers.map(answer => (
                    <td className="text-center" key={answer.value}>
                      {(answer.loop_instances || []).map((loop) => {
                        if (loop.value === header.value) {
                          return <Fa name="check" />;
                        }
                        return null;
                      })}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    const verticalCls = headers.length > 3 ? styles.tableVerticalHeaders : null;

    return (
      <div className={`${className} ${verticalCls}`}>
        <table className="table table-condensed">
          <thead>
            <tr>
              <th>&nbsp;</th>
              {headers.map(header => (
                <th className="text-center" key={header.value}>
                  {header.text}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {answers.map(answer => (
              <tr key={answer.value}>
                <th>{this.renderHTML(answer.text)}</th>
                {headers.map(header => (
                  <td className="text-center" key={header.value}>
                    {(answer.loop_instances || []).map((loop) => {
                      if (loop.value === header.value) {
                        return <Fa name="check" />;
                      }
                      return null;
                    })}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  renderType1NonLoop() {
    // Single Select, non looping
    return this.renderGeneric();
  }
  renderType1() {
    // Single select
    if (this.props.isLooping) {
      return this.renderType1Loop();
    }
    return this.renderType1NonLoop();
  }


  renderType2Loop() {
    // multi select, loopping
    return this.renderType1Loop(); // same layout

  }
  renderType2NonLoop() {
    // multi select, non loopping
    const { answers, className } = this.props;
    return answers.map(answer => (
      <div key={answer.value} className={className}>
        <table>
          <tbody>
            <tr>
              <td width="30" className="text-center"><Fa name="check" /></td>
              <td>{this.renderHTML(answer.text)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    ));
  }
  renderType2() {
    // multi Select 
    if (this.props.isLooping) {
      return this.renderType2Loop();
    }
    return this.renderType2NonLoop();
  }

  renderType3Loop() {
    // Open End, looping
    return this.renderGeneric();
  }
  renderType3NonLoop() {
    // Open End, non looping
    return this.renderGeneric();
  }
  renderType3() {
    // Open End
    if (this.props.isLooping) {
      return this.renderType3Loop();
    }
    return this.renderType3NonLoop();
  }

  renderType4() {
    // Ranking
    const { answers, className } = this.props;
    return answers.map(answer => (
      <div key={answer.value} className={className}>
        <table>
          <tbody>
            <tr>
              <td width="30" className="text-right">
                {answer.response_value}<sup>{ordinal.ordinalSuffix(parseInt(answer.response_value, 10))}</sup>&nbsp;&nbsp;&nbsp;
              </td>
              <td>{this.renderHTML(answer.text)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    ));
  }
  renderType5Loop() {
    // Matrix, looping
    const { answers, className } = this.props;
    const header = first(answers);
    const verticalCls = header && header.loop_instances && header.loop_instances.length > 3 ? styles.tableVerticalHeaders : null;

    return (
      <div className={`${className} ${verticalCls}`}>
        <table className="table table-condensed">
          <thead>
            {header !== undefined &&
              <tr>
                <th>&nbsp;</th>
                {(header.loop_instances || []).map(loop => (
                  <th className="text-center" key={loop.value}>
                    {loop.text}
                  </th>
                ))}
              </tr>
            }
          </thead>
          <tbody>
            {answers.map(answer => (
              <tr key={answer.value}>
                <th>{this.renderHTML(answer.text)}</th>
                {(answer.loop_instances || []).map(loop => (
                  <td key={loop.value} className="text-center">
                    {loop.response}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  renderType5NonLoop() {
    // Matrix, non looping
    const { answers, className } = this.props;
    return (
      <div className={className}>
        <table className={`table table-condensed ${styles.noHeader}`}>
          <tbody>
            {answers.map(answer => (
              <tr key={answer.value}>
                <td>{this.renderHTML(answer.text)}</td>
                <td>{answer.response_text}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  renderType5() {
    // Matrix
    if (this.props.isLooping) {
      return this.renderType5Loop();
    }
    return this.renderType5NonLoop();
  }

  renderType7() {
    // Date
    const { answers, className } = this.props;
    return answers.map((answer, idx) => (
      <div key={`answer-${idx}`} className={className}>
        {answer.text} {answer.response_text}
      </div>
    ));
  }

  renderType8() {
    const { answers, className } = this.props;
    return (
      <div className={className}>
        <table className={`table table-condensed ${styles.noHeader}`}>
          <tbody>
            {answers.map((answer, idx) => (
              <tr key={`answer-${idx}`}>
                <th>{this.renderHTML(answer.response_text)}</th>
                <td>{this.renderHTML(answer.text)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { questionType } = this.props;
    if (questionType === 1) {
      return this.renderType1();
    } else if (questionType === 2) {
      return this.renderType2();
    } else if (questionType === 3) {
      return this.renderType3();
    } else if (questionType === 4) {
      return this.renderType4();
    } else if (questionType === 5) {
      return this.renderType5();
    } else if (questionType === 7) {
      return this.renderType7();
    } else if (questionType === 8) {
      return this.renderType8();
    }
    return this.renderGeneric();
  }
}

AnswerBox.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    text: PropTypes.string,
  })),
  className: PropTypes.string,
  isLooping: PropTypes.bool.isRequired,
  questionType: PropTypes.number.isRequired,
};
AnswerBox.defaultProps = {
  answers: null,
  className: null,
};

export default AnswerBox;
